import React, { useEffect } from "react";
import {
  CABIN_CODE,
  CABIN_VALUE,
  filterCabinDeductibleNotAvailableForCustomer,
  filterCoveragesOnCoverage,
} from "../../../houseProductsUtils";

import { FormGroupWrap } from "Components/Features/CheckPrice/Products/Advice/ProductDetails/FormElements/styled";
import { FormText } from "Components/Features/CheckPrice/Products/productInterfaces";
import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { RecentDamages } from "Components/Form/RecentDamages";
import { StyledDesc } from "Components/InsuranceDetailsCard/CardHeader/styled";
import { CabinContentsCoverage } from "Store/interfaces/products/coverage";
import { useCoveragePriceCalculations } from "Store/priceCalculation/priceCalculationHooks";
import { TextLanguage } from "Store/texts/interfaces";
import { useDebounce } from "Utils/debounce";
import { formBooleanToBoolean } from "Utils/formUtils";
import { isEmpty } from "Utils/functions";
import { FormikProps } from "formik";
import { AddContentsInsurance } from "../../../FormComponentsHouseProducts/AddContentsInsurance";
import { InsuranceSumInput } from "../../../FormComponentsHouseProducts/FormComponentsCabinProducts/InsuranceSumInput";
import { CabinPriceFormValues } from "../cabinProductPriceInterfaces";
import { StyledDescHeader } from "../cabinProductPriceStyled";
import { CoveragesAndDeductible } from "./CoveragesAndDeductible";

interface Props {
  formProps: FormikProps<CabinPriceFormValues>;
  checkPriceText: FormText;
  lang: TextLanguage;
  updateCabinPriceCalculation: (
    formProps: FormikProps<CabinPriceFormValues>,
  ) => void;
  isLoading: boolean;
}

export const CabinContents = ({
  formProps,
  checkPriceText,
  lang,
  updateCabinPriceCalculation,
  isLoading,
}: Props): React.ReactElement => {
  const debounce = useDebounce();
  const coverages = useCoveragePriceCalculations();
  const filteredCabinContentsCoverages = filterCoveragesOnCoverage(
    Object.values(CabinContentsCoverage),
    coverages,
  );
  const cabinContentsCoverages = filterCabinDeductibleNotAvailableForCustomer(
    CABIN_CODE,
    CABIN_VALUE,
    filteredCabinContentsCoverages,
  );
  const handleContentsFormPriceFieldChange = async (): Promise<void> => {
    const formErrors = await formProps.validateForm();
    if (isEmpty(formErrors)) {
      updateCabinPriceCalculation(formProps);
    }
  };
  useEffect(
    () => debounce(handleContentsFormPriceFieldChange),
    [
      formProps.values.contentsInsuranceSum,
      formProps.values.injuries,
      formProps.values.injuryYear,
    ],
  );
  return (
    <FormGroupWrap>
      <StyledDescHeader>
        {checkPriceText.contentsInsurance.introduction.label[lang]}
      </StyledDescHeader>
      <StyledDesc>
        {checkPriceText.contentsInsurance.introduction.hint[lang]}
      </StyledDesc>
      <AddContentsInsurance
        formProps={formProps}
        lang={lang}
        name="addContentsInsurance"
      />
      {formBooleanToBoolean(formProps.values.addContentsInsurance) && (
        <>
          <RecentDamages
            formProps={formProps}
            productName={ProductBackendName.CABIN_CONTENTS}
          />
          <InsuranceSumInput formProps={formProps} lang={lang} />

          <CoveragesAndDeductible
            formProps={formProps}
            coverages={cabinContentsCoverages}
            checkPriceText={checkPriceText}
            lang={lang}
            isLoading={isLoading}
          />
        </>
      )}
    </FormGroupWrap>
  );
};
